<section class="branches-page">
    <!-- HERO -->
    <section class="branches-hero">
        <div class="branches-hero__content">
            <div class="branches-hero__breadcrumb">
                Inicio / Sucursales
            </div>
            <h1>
                Nuestras <span>sucursales</span>
            </h1>
            <p>
                {{ sucursales.length || 16 }} sucursales en La Comarca Lagunera
                —Torreón, Gómez Palacio y Lerdo— para recoger tu pedido
                o antojarte en mostrador.
            </p>
        </div>
    </section>
    <!-- CONTENIDO -->
    <section class="branches-content">
        <h2>Nuestras sucursales y mapa</h2>
        <div class="branches-layout">
            <!-- LISTA DE SUCURSALES -->
            <div class="branches-list">
                <div class="branch-card" *ngFor="let branch of sucursales"
                    [class.branch-card--selected]="isSelectedBranch(branch)" (click)="selectedBranch(branch)">
                    <!-- FOTO -->
                    <div class="branch-card__image">
                        <img [src]="branch.urlFoto" [alt]="'Sucursal ' + branch.nombre">
                    </div>
                    <!-- INFORMACIÓN -->
                    <div class="branch-card__content">
                        <h3>
                            {{ formatBranchName(branch.nombre) }}
                        </h3>
                        <p class="branch-card__address">
                            {{ branch.direccion }}
                        </p>
                        <p class="branch-card__schedule">
                            {{ branch.horario }}
                        </p>
                        <div class="branch-card__actions">
                            <!-- <button type="button" class="branch-card__button branch-card__button--primary"
                                (click)="pedirEnSucursal(branch, $event)">
                                <span class="material-symbols-outlined">
                                    shopping_bag
                                </span>
                                Pedir aquí
                            </button> -->
                            <button type="button" class="branch-card__button branch-card__button--secondary"
                                (click)="comoLlegar(branch, $event)">
                                Cómo llegar
                            </button>
                        </div>
                    </div>
                </div>
            </div>


            <!-- MAPA -->
            <div class="branches-map">
                <agm-map [latitude]="lat" [longitude]="lng" [zoom]="zoom" (mapClick)="onMapClickEvent($event)">
                    <agm-marker *ngFor="let branch of sucursales" [latitude]="toNumber(branch.latitud)"
                        [longitude]="toNumber(branch.longitud)" [markerClickable]="true"
                        (markerClick)="selectedBranch(branch, infoWindow)">
                        <agm-info-window #infoWindow>
                            <div class="branch-map-info">
                                <strong>
                                    {{ formatBranchName(branch.nombre) }}
                                </strong>
                                <span>
                                    {{ branch.direccion }}
                                </span>
                            </div>
                        </agm-info-window>
                    </agm-marker>
                </agm-map>
            </div>
        </div>
    </section>
</section>